import * as React from 'react';
import { Trigger, TriggerProps } from '@easyv/react-components';
import classNames from 'classnames';

interface HintTooltipProps extends Omit<TriggerProps, 'content'> {
  className?: string;
  hidden?: boolean;
  content: React.ReactNode;
}

export const HintPopup: React.FC<HintTooltipProps> = (props) => {
  const { className, content } = props;

  return (
    <div
      className={classNames(
        'px-1 text-white bg-bgColor17171A h-[18px] border rounded-sm border-black',
        className,
      )}
    >
      {content}
    </div>
  );
};

export const HintTooltip: React.FC<React.PropsWithChildren<HintTooltipProps>> = (props) => {
  const { content, children, hidden = false, ...rest } = props;

  return (
    <Trigger
      disabled={hidden}
      alignPoint
      position='bl'
      popupAlign={{ bottom: 9, left: 6 }}
      popup={() => <HintPopup content={content} />}
      {...rest}
    >
      {children}
    </Trigger>
  );
};
